module.exports = "/images/media.svg?c03ca433515d406b966f056f410aa2ff";